import PageHeader from "../components/PageHeader";
import {
  FaHotel,
  FaPlane,
  FaCar,
  FaMapMarkedAlt,
  FaHeadset,
  FaShieldAlt,
  FaUtensils,
  FaPassport
} from "react-icons/fa";

import { Helmet } from "react-helmet-async";
import aboutImg from "../assets/images/aboutUs.jpg";

export default function Services() {

  const services = [
    {
      icon: <FaHotel />,
      title: "Hotel Booking Worldwide",
      desc: "Access thousands of hotels worldwide with competitive rates, instant confirmation, and flexible booking options.",
      link: "/hotels",
    },
    {
      icon: <FaPlane />,
      title: "Flight Booking",
      desc: "Book domestic and international flights with exclusive fares, flexible schedules, and trusted airline partners.",
      link: "https://southtravels.com/flights",
    },
    {
      icon: <FaPassport />,
      title: "Visa Assistance",
      desc: "Professional visa support and documentation assistance for tourist, business, and transit travel requirements.",
      link: "https://southtravels.com/dubai-visit-visa",
    },
    {
      icon: <FaMapMarkedAlt />,
      title: "Tours & Activities",
      desc: "Discover unforgettable sightseeing experiences, city tours, desert safaris, attractions, and adventure activities.",
      link: "https://tourismindubai.com/",
    },
    {
      icon: <FaCar />,
      title: "Car Rentals",
      desc: "Choose from economy to luxury vehicles with flexible rental plans and convenient pickup options.",
      link: "https://southtravels.com/car-rental-from-dubai",
    },
    {
      icon: <FaShieldAlt />,
      title: "Airport Transfers",
      desc: "Reliable private and shared airport transfer services ensuring a smooth journey from arrival to destination.",
      link: "https://southtravels.com/",
    },
    {
      icon: <FaHeadset />,
      title: "Cruise Booking",
      desc: "Explore premium cruise vacations featuring luxury accommodations, entertainment, and world-class destinations.",
      link: "https://dhow-cruise-dubai.com/",
    },
    {
      icon: <FaMapMarkedAlt />,
      title: "Holiday Packages",
      desc: "Carefully curated holiday packages combining flights, hotels, transfers, and experiences at exceptional value.",
      link: "https://southtravels.com/holidays",
    },
  ];

  return (
    <>
      <Helmet>
        {/* Basic SEO */}
        <title>Our Services | UAE Dubai Hotels</title>

        <meta
          name="description"
          content="Explore the services offered by UAE Dubai Hotels, including hotel bookings, luxury stays, budget accommodations, family-friendly hotels, business stays, and exclusive hotel deals across Dubai and the UAE."
        />

        <meta
          name="keywords"
          content="UAE Dubai Hotels services, hotel booking UAE, Dubai hotel booking, discounted hotels UAE, luxury hotels Dubai, budget hotels UAE, family hotels Dubai, business hotels UAE, hotel deals Dubai, Abu Dhabi hotels"
        />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="UAE Dubai Hotels" />

        {/* Canonical */}
        <link
          rel="canonical"
          href="https://uaedubaihotels.com/services"
        />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="UAE Dubai Hotels" />
        <meta property="og:locale" content="en_US" />

        <meta
          property="og:title"
          content="Our Services | UAE Dubai Hotels"
        />

        <meta
          property="og:description"
          content="Discover hotel booking services, exclusive accommodation deals, luxury stays, and affordable hotels across Dubai, Abu Dhabi, Sharjah, and the UAE with UAE Dubai Hotels."
        />

        <meta
          property="og:url"
          content="https://uaedubaihotels.com/services"
        />

        <meta
          property="og:image"
          content="https://uaedubaihotels.com/images/default-og.png"
        />

        {/* Twitter */}
        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content="Our Services | UAE Dubai Hotels"
        />

        <meta
          name="twitter:description"
          content="Learn about UAE Dubai Hotels services including hotel reservations, affordable stays, luxury accommodations, and exclusive hotel offers across the UAE."
        />

        <meta
          name="twitter:image"
          content="https://uaedubaihotels.com/images/default-og.png"
        />
      </Helmet>

      <div className="
w-full
bg-[#FCFAF5]
dark:bg-gray-950
transition
">


        {/* HERO BANNER */}

        <section
          className="
relative
h-[380px]
md:h-[420px]
flex
items-center
bg-cover
bg-center
"
          style={{
            backgroundImage:
              `linear-gradient(rgba(0,0,0,.65),rgba(0,0,0,.65)), url(${aboutImg})`
          }}
        >


          <div className="
container
mx-auto
px-6
text-white
">

            <p className="
uppercase
tracking-[0.3em]
text-[#D4B76A]
text-sm
mb-5
">
              Our Services
            </p>


            <h1
              className="
        text-2xl
        sm:text-3xl
        md:text-5xl
        font-serif
        max-w-3xl
        leading-tight
    "
            >
              Complete UAE Travel
              Solutions Under One Roof
            </h1>


            <p className="
mt-5
max-w-xl
text-white/80
leading-relaxed
">

              From luxury hotel bookings to airport
              transfers and travel experiences,
              we make every journey effortless.

            </p>


          </div>


        </section>






        {/* INTRO */}

        <section className="
container
mx-auto
px-6
py-20
text-center
">


          <p className="
text-[#0F766E]
uppercase
tracking-widest
text-sm
">
            Explore Our Services
          </p>


          <h2 className="
mt-3
text-4xl
font-serif
text-[#1F2937]
dark:text-white
">

            Everything You Need For
            A Perfect UAE Experience

          </h2>


          <p className="
mt-5
max-w-2xl
mx-auto
text-gray-500
dark:text-gray-400
">

            Whether you are planning a luxury holiday,
            business trip, or family vacation,
            our services are designed around your comfort.

          </p>


        </section>







        {/* SERVICES CARDS */}


        <section className="
container
mx-auto
px-6
pb-20
">


          <div className="
grid
sm:grid-cols-2
lg:grid-cols-4
gap-6
">


            {
              services.map((s, i) => (


                <a

                  key={i}

                  href={s.link}

                  className="
group
relative
overflow-hidden
bg-white
dark:bg-gray-900
border
border-[#DDD2BA]
rounded-[32px]
p-7
transition
duration-500
hover:-translate-y-3
hover:shadow-2xl
"


                >


                  {/* ICON */}

                  <div className="
w-16
h-16
rounded-2xl
bg-[#EFE7D5]
text-[#0F766E]
flex
items-center
justify-center
text-2xl
mb-6
group-hover:bg-[#0F766E]
group-hover:text-white
transition
">

                    {s.icon}

                  </div>



                  <h3 className="
text-lg
font-semibold
text-[#1F2937]
dark:text-white
">

                    {s.title}

                  </h3>



                  <p className="
mt-3
text-sm
leading-6
text-gray-500
dark:text-gray-400
">

                    {s.desc}

                  </p>




                  <div className="
mt-6
inline-flex
items-center
text-sm
font-semibold
text-[#B89442]
group-hover:text-[#0F766E]
transition
">

                    Explore →

                  </div>




                  {/* Hover Glow */}

                  <div className="
absolute
-w-20
h-20
bg-[#B89442]/10
rounded-full
blur-3xl
group-hover:scale-150
transition
">

                  </div>


                </a>


              ))
            }



          </div>


        </section>








        {/* WHY CHOOSE */}


        <section
          className="
        bg-white
        dark:bg-gray-900
        py-0
        md:py-20
    "
        >


          <div className="
container
mx-auto
px-6
">


            <div className="
grid
md:grid-cols-3
gap-6
">


              {


                [
                  {
                    icon: <FaHotel />,
                    title: "Verified Hotels",
                    text: "Handpicked properties offering quality stays."
                  },

                  {
                    icon: <FaShieldAlt />,
                    title: "Secure Booking",
                    text: "Safe and reliable reservation experience."
                  },

                  {
                    icon: <FaHeadset />,
                    title: "24/7 Support",
                    text: "Our team is always ready to assist."
                  }


                ].map((item, index) => (


                  <div
                    key={index}
                    className="
p-8
rounded-[32px]
bg-[#FCFAF5]
dark:bg-gray-800
border
border-[#DDD2BA]
"
                  >


                    <div className="
w-14
h-14
rounded-full
bg-[#0F766E]
text-white
flex
items-center
justify-center
text-xl
">

                      {item.icon}

                    </div>


                    <h3 className="
mt-5
font-bold
text-xl
dark:text-white
">

                      {item.title}

                    </h3>


                    <p className="
mt-3
text-gray-500
dark:text-gray-300
">

                      {item.text}

                    </p>


                  </div>


                ))


              }



            </div>


          </div>


        </section>







        {/* CTA */}


        <section className="
mx-6
my-20
rounded-[40px]
bg-[#111827]
py-16
text-center
px-6
">


          <h2 className="
text-4xl
font-serif
text-white
">

            Ready To Plan Your UAE Experience?

          </h2>


          <p className="
mt-5
text-white/70
max-w-xl
mx-auto
">

            Discover amazing hotels,
            exclusive offers and unforgettable
            travel experiences.

          </p>


          <a
            href="/hotels"
            className="
inline-block
mt-8
px-8
py-3
rounded-full
bg-[#B89442]
text-white
font-semibold
hover:bg-[#0F766E]
transition
"
          >

            Browse Hotels →

          </a>


        </section>




      </div>
    </>
  );
}